import React from 'react';

const TableGamesIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.33301 9.98802C1.33301 7.79635 1.33301 6.70054 1.93831 5.96297C2.04913 5.82794 2.17293 5.70414 2.30796 5.59332C3.04553 4.98802 4.14135 4.98802 6.33301 4.98802H9.66634C11.858 4.98802 12.9538 4.98802 13.6914 5.59332C13.8264 5.70414 13.9502 5.82794 14.061 5.96297C14.6663 6.70054 14.6663 7.79635 14.6663 9.98802C14.6663 12.1797 14.6663 13.2755 14.061 14.0131C13.9502 14.1481 13.8264 14.2719 13.6914 14.3827C12.9538 14.988 11.858 14.988 9.66634 14.988H6.33301C4.14135 14.988 3.04553 14.988 2.30796 14.3827C2.17293 14.2719 2.04913 14.1481 1.93831 14.0131C1.33301 13.2755 1.33301 12.1797 1.33301 9.98802Z",
      stroke: "#E2E4EE",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8 4.98802V3.65468C8 3.2865 8.29847 2.98802 8.66667 2.98802C9.03487 2.98802 9.33333 2.68954 9.33333 2.32135V1.65468",
      stroke: "#E2E4EE",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.66699 10.988L5.66699 9.98802M5.66699 9.98802L4.66699 8.98802M5.66699 9.98802L4.66699 10.988M5.66699 9.98802L6.66699 8.98802",
      stroke: "#E2E4EE",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.333 10.6547V9.32135",
      stroke: "#E2E4EE",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
TableGamesIcon.displayName = "Icons.TableGamesIcon";

export { TableGamesIcon };
//# sourceMappingURL=TableGamesIcon.js.map
